//@flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Banner } from 'components/atoms/banner';
import { FooterExploreButton } from 'components/atoms/footerExploreButton';
import { useViewport } from 'components/templates/viewportProvider';
import { BannerVideoButton } from 'components/atoms/bannerVideoButton';
//eslint-disable-next-line
import "./styles.scss";

type Props = {
  theme: string,
  data: {
    craftBeerBanner: any,
  },
};

const CraftBeerBreweryBanner = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    craftBeerBanner: {
      title,
      image,
      image_mobile,
      thumbnail,
      thumbnail_mobile,
      banner_video,
    },
  } = props.data;

  const animationClasses = ['animate-height', 'animate-width'];

  let bannerImageUrl = image;
  let thumbNailUrl = thumbnail;
  let className = 'craftBeer-banner';
  if (isMobile) {
    bannerImageUrl = image_mobile;
    thumbNailUrl = thumbnail_mobile;
  }

  return (
    <div className={className} style={{ height }} id={'banner'}>
      <Banner
        imageUrl={bannerImageUrl}
        thumbNailUrl={thumbNailUrl}
        title={title}
        containerClassName={'intro'}
        bannerText={'title'}
        bannerImage={animationClasses.join(' ')}
      />
      {banner_video && <BannerVideoButton videoUrl={banner_video} />}
      {isMobile && <FooterExploreButton sectionName={'brewery'} />}
    </div>
  );
};

export default withRouter(CraftBeerBreweryBanner);
